/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import canaryLogo from '@/assets/canary/CanaryLabs_Logo.svg'
import avevaLogo from '@/assets/aveva/Aveva_logo.svg'

const handleStyleLeft = { left: -2, top: 44 }

function HistorianNode({ data, isConnectable }) {
  const historianLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return avevaLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return canaryLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return canaryLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return canaryLogo
    }
  }
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={historianLogo()} alt="Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Historian</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HistorianNode
